<template>
  <div class="oss-uploader">
    <!-- <slot :file-list="fileList"> -->
    <template v-if="isInput=='true'">
      <div class="upload_box2">
        <img class="upload_img" src="@/assets/images/upload/upload.png" />
        <p class="upload_title">点击上传</p>
        <input type="file" class="file_btn" :multiple="isReviewManagement" :accept="accept" @change="choosefile">
      </div>
    </template>
    <el-upload v-else class="uploader-btn" action="" ref="upload" :show-file-list="false" :file-list="fileList"
      :limit="uploadLimit" :multiple="isReviewManagement" :on-exceed="onExceed" :on-change="handleChange"
      :auto-upload="false" :accept="accept">
      <div class="upload_box">
        <img class="upload_img" src="@/assets/images/upload/upload.png" />
        <p class="upload_title">点击上传</p>
      </div>
      <!-- <el-button slot="trigger" size="small" type="primary">选取文件</el-button> -->
      <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitForm">上传到服务器</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="resumeUpload">继续</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="stopUplosd">暂停</el-button>
        <el-button style="margin-left: 10px;" size="small" type="success" @click="abortMultipartUpload">清除切片</el-button> -->
    </el-upload>
    <!-- <p v-if="isInput != 'true'" class="upload-limit-hint">最多上传 {{ uploadLimit }} 个文件</p> -->

    <ul>
      <li v-for="(file,index) in fileList" :key="index">
        <oss-uploader-file  :file="file" @closeMain="closeMain" :list="true" :isInput="isInput" :sourceType="sourceType"></oss-uploader-file>
      </li>
    </ul>
    <!-- </slot> -->
  </div>
</template>

<script>
  import OssUploaderFile from "./oss-file.vue";

  const COMPONENT_NAME = "oss-uploader";

  export default {
    name: COMPONENT_NAME,
    props: {
      isInput: String,
      accept:String,
      sourceType:Number,
      AdjustTheType:String
    },
    computed: {
      isReviewManagement() {
        return this.AdjustTheType === 'ReviewManagement';
      },
      /**
       * ReviewManagement：不设 limit，图片等非视频文件数量不受 el-upload 总数限制；
       * 视频仅 1 条在 applyReviewManagementVideoRule + handleChange 中处理。
       * 其它场景：总数最多 5 个。
       */
      uploadLimit() {
        if (this.isReviewManagement) {
          return undefined;
        }
        return 5;
      },
    },
    data() {
      return {
        fileList: []
      };
    },
    methods: {
      choosefile(e) {
        const files = e.target.files;
        if (!files || !files.length) return;
        const list = Array.from(files).map((raw) => ({
          name: raw.name,
          size: raw.size,
          raw,
        }));
        const allowed = list.filter((f) => this.matchAccept(f));
        if (allowed.length !== list.length) {
          this.$message.warning(`仅支持上传 ${this.accept} 格式的文件`);
        }
        this.fileList = allowed;
        e.target.value = '';
      },
      matchAccept(file) {
        if (!this.accept || !String(this.accept).trim()) return true;
        const name = ((file && file.name) || '').toLowerCase();
        const ext = name.includes('.') ? `.${name.split('.').pop()}` : '';
        const allowed = String(this.accept)
          .split(',')
          .map((s) => s.trim().toLowerCase())
          .filter(Boolean);
        return allowed.includes(ext);
      },
      closeMain(data) {
        this.$emit('closeMain', data);
      },
      onExceed() {
        if (this.isReviewManagement) {
          return;
        }
        this.$message.warning(
          `最多只能上传 ${this.uploadLimit} 个文件，请先删除已选文件后再试`
        );
      },
      isVideoFile(file) {
        const raw = file && file.raw;
        const type = (raw && raw.type) || '';
        if (type.startsWith('video/')) return true;
        const name = ((file && file.name) || '').toLowerCase();
        return /\.(mp4|webm|ogg|mov|avi|mkv|wmv|flv|m4v|3gp)(\?.*)?$/.test(name);
      },
      /** ReviewManagement：仅保留列表中第一个视频，其余视频移除 */
      applyReviewManagementVideoRule(fileList) {
        let removedExtraVideo = false;
        let seenVideo = false;
        const next = [];
        for (const f of fileList) {
          if (this.isVideoFile(f)) {
            if (!seenVideo) {
              seenVideo = true;
              next.push(f);
            } else {
              removedExtraVideo = true;
            }
          } else {
            next.push(f);
          }
        }
        return { list: next, removedExtraVideo };
      },
      handleChange(file, fileList) {
        let list = fileList.filter((f) => this.matchAccept(f));
        if (list.length !== fileList.length) {
          this.$message.warning(`仅支持上传 ${this.accept} 格式的文件`);
        }
        if (this.isReviewManagement) {
          const { list: nextList, removedExtraVideo } =
            this.applyReviewManagementVideoRule(list);
          list = nextList;
          if (removedExtraVideo) {
            this.$message.warning('只能上传一个视频');
          }
        }
        this.fileList = list;
        if (this.matchAccept(file)) {
          this.$emit('Lxupload', file);
        }
      },
      /** 拖拽到 zone 上传区时注入文件（与 el-upload 选中效果一致） */
      addRawFiles(files) {
        const raws = Array.isArray(files) ? files : [];
        if (!raws.length) return;
        const newItems = raws.map((raw, i) => ({
          name: raw.name,
          size: raw.size,
          raw,
          uid: `drop-${Date.now()}-${i}`,
          status: 'ready',
        }));
        let list = this.fileList.concat(newItems);
        if (this.isReviewManagement) {
          const { list: nextList, removedExtraVideo } =
            this.applyReviewManagementVideoRule(list);
          list = nextList;
          if (removedExtraVideo) {
            this.$message.warning('只能上传一个视频');
          }
        }
        this.fileList = list;
        newItems.forEach((f) => this.$emit('Lxupload', f));
      },
      fatherMethod(file) {
        if (this.isInput == 'true') {
          this.fileList = []
        }else{
          this.fileList = this.fileList.filter(row => row.uid !== file.uid)
        }
      }

    },
    components: {
      OssUploaderFile
    }
  };
</script>

<style>
  .oss-uploader {
    position: relative;
  }

  .uploader-btn {
    display: inline-block;
    position: relative;
    padding: 10px 15px;
    font-size: 100%;
    line-height: 1.4;
    color: #666;
    /* border: 1px dashed #666; */
    cursor: pointer;
    border-radius: 2px;
    background: none;
    outline: none;
  }

  .upload_box {
    padding: 10px 20px;
    text-align: center;
    border-radius: 5px;
    border: 1px dashed #409eff;
  }

  .upload_box2 {
    position: relative;
    padding: 10px 20px;
    text-align: center;
    border-radius: 5px;
    border: 1px dashed #409eff;
    width: 60px;
    margin: 0 auto;
  }

  .upload_box2>.file_btn {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    outline: none;
    background-color: transparent;
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    opacity: 0;
  }

  .upload_img {
    height: 25px;
    vertical-align: middle;
  }

  .upload_title {
    color: #409eff;
    padding-top: 5px;
    font-size: 14px;
    vertical-align: middle;
  }

  .upload_box:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }

  .oss-uploader>ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .upload-limit-hint {
    margin: 6px 0 0;
    padding: 10px 15px;
    font-size: 12px;
    line-height: 1.4;
    color: #909399;
  }
</style>